import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BlameSource = /*#__PURE__*/function (BlameSource) {
  BlameSource[BlameSource["BLAME_SOURCE_SYSTEM"] = 0] = "BLAME_SOURCE_SYSTEM";
  BlameSource[BlameSource["BLAME_SOURCE_USER"] = 1] = "BLAME_SOURCE_USER";
  return BlameSource;
}(BlameSource || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActivationStatus = /*#__PURE__*/function (ActivationStatus) {
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_NOT_SPECIFIED"] = 0] = "ACTIVATION_STATUS_NOT_SPECIFIED";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_ACTIVATED"] = 1] = "ACTIVATION_STATUS_ACTIVATED";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_PENDING"] = 2] = "ACTIVATION_STATUS_PENDING";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_CANCELED"] = 3] = "ACTIVATION_STATUS_CANCELED";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_DEACTIVATED"] = 4] = "ACTIVATION_STATUS_DEACTIVATED";
  return ActivationStatus;
}(ActivationStatus || {});
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Blame {
  static fromProto(proto) {
    let m = new Blame();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$1(BlameSource, proto.source);
    }
    if (proto.reasons) {
      m.reasons = BlameDeactivationReasons.fromProto(proto.reasons);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.sourceIdentifier !== 'undefined') {
      toReturn['sourceIdentifier'] = this.sourceIdentifier;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.reasons !== 'undefined' && this.reasons !== null) {
      toReturn['reasons'] = 'toApiJson' in this.reasons ? this.reasons.toApiJson() : this.reasons;
    }
    return toReturn;
  }
}
class BlameDeactivationReasons {
  static fromProto(proto) {
    let m = new BlameDeactivationReasons();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.choices !== 'undefined') {
      toReturn['choices'] = this.choices;
    }
    if (typeof this.comments !== 'undefined') {
      toReturn['comments'] = this.comments;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivateProductRequest {
  static fromProto(proto) {
    let m = new ActivateProductRequest();
    m = Object.assign(m, proto);
    if (proto.activationInfo) {
      m.activationInfo = Blame.fromProto(proto.activationInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.activationInfo !== 'undefined' && this.activationInfo !== null) {
      toReturn['activationInfo'] = 'toApiJson' in this.activationInfo ? this.activationInfo.toApiJson() : this.activationInfo;
    }
    if (typeof this.billingOrderId !== 'undefined') {
      toReturn['billingOrderId'] = this.billingOrderId;
    }
    if (typeof this.backdateToParentActivation !== 'undefined') {
      toReturn['backdateToParentActivation'] = this.backdateToParentActivation;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.trialDuration !== 'undefined') {
      toReturn['trialDuration'] = this.trialDuration;
    }
    if (typeof this.vendorOrderId !== 'undefined') {
      toReturn['vendorOrderId'] = this.vendorOrderId;
    }
    return toReturn;
  }
}
class ActivateProductResponse {
  static fromProto(proto) {
    let m = new ActivateProductResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class ListActiveAccountsForProductResponseActiveProducts {
  static fromProto(proto) {
    let m = new ListActiveAccountsForProductResponseActiveProducts();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetMultiActivationStatusesResponseAppsAndAddonsActivationStatuses {
  static fromProto(proto) {
    let m = new GetMultiActivationStatusesResponseAppsAndAddonsActivationStatuses();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(ActivationStatus, proto.status);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ChangeEditionRequest {
  static fromProto(proto) {
    let m = new ChangeEditionRequest();
    m = Object.assign(m, proto);
    if (proto.changeDate) {
      m.changeDate = new Date(proto.changeDate);
    }
    if (proto.changeEditionInfo) {
      m.changeEditionInfo = Blame.fromProto(proto.changeEditionInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.billingOrderId !== 'undefined') {
      toReturn['billingOrderId'] = this.billingOrderId;
    }
    if (typeof this.changeDate !== 'undefined' && this.changeDate !== null) {
      toReturn['changeDate'] = 'toApiJson' in this.changeDate ? this.changeDate.toApiJson() : this.changeDate;
    }
    if (typeof this.changeEditionInfo !== 'undefined' && this.changeEditionInfo !== null) {
      toReturn['changeEditionInfo'] = 'toApiJson' in this.changeEditionInfo ? this.changeEditionInfo.toApiJson() : this.changeEditionInfo;
    }
    if (typeof this.vendorOrderId !== 'undefined') {
      toReturn['vendorOrderId'] = this.vendorOrderId;
    }
    return toReturn;
  }
}
class ChangeEditionResponse {
  static fromProto(proto) {
    let m = new ChangeEditionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    return toReturn;
  }
}
class GetMultiActivationStatusesRequest {
  static fromProto(proto) {
    let m = new GetMultiActivationStatusesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
class GetMultiActivationStatusesResponse {
  static fromProto(proto) {
    let m = new GetMultiActivationStatusesResponse();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = proto.activationStatuses.map(GetMultiActivationStatusesResponseAppsAndAddonsActivationStatuses.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activationStatuses !== 'undefined' && this.activationStatuses !== null) {
      toReturn['activationStatuses'] = 'toApiJson' in this.activationStatuses ? this.activationStatuses.toApiJson() : this.activationStatuses;
    }
    return toReturn;
  }
}
class ListActiveAccountsForProductRequest {
  static fromProto(proto) {
    let m = new ListActiveAccountsForProductRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListActiveAccountsForProductResponse {
  static fromProto(proto) {
    let m = new ListActiveAccountsForProductResponse();
    m = Object.assign(m, proto);
    if (proto.activeProducts) {
      m.activeProducts = proto.activeProducts.map(ListActiveAccountsForProductResponseActiveProducts.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activeProducts !== 'undefined' && this.activeProducts !== null) {
      toReturn['activeProducts'] = 'toApiJson' in this.activeProducts ? this.activeProducts.toApiJson() : this.activeProducts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'accounts.vendasta-local.com',
  'test': '',
  'demo': 'accounts-demo.apigateway.co',
  'prod': 'accounts-prod.apigateway.co',
  'production': 'accounts-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AccountsApiService = /*#__PURE__*/(() => {
  class AccountsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    activateProduct(r) {
      const request = r.toApiJson ? r : new ActivateProductRequest(r);
      return this.http.post(this._host + "/accounts.v2.AccountsService/ActivateProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => ActivateProductResponse.fromProto(resp)));
    }
    getMultiActivationStatuses(r) {
      const request = r.toApiJson ? r : new GetMultiActivationStatusesRequest(r);
      return this.http.post(this._host + "/accounts.v2.AccountsService/GetMultiActivationStatuses", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiActivationStatusesResponse.fromProto(resp)));
    }
    changeEdition(r) {
      const request = r.toApiJson ? r : new ChangeEditionRequest(r);
      return this.http.post(this._host + "/accounts.v2.AccountsService/ChangeEdition", request.toApiJson(), this.apiOptions()).pipe(map(resp => ChangeEditionResponse.fromProto(resp)));
    }
    listActiveAccountsForProduct(r) {
      const request = r.toApiJson ? r : new ListActiveAccountsForProductRequest(r);
      return this.http.post(this._host + "/accounts.v2.AccountsService/ListActiveAccountsForProduct", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActiveAccountsForProductResponse.fromProto(resp)));
    }
  }
  AccountsApiService.ɵfac = function AccountsApiService_Factory(t) {
    return new (t || AccountsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsApiService,
    factory: AccountsApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unsafe-call */
let AccountsService = /*#__PURE__*/(() => {
  class AccountsService {
    constructor(api) {
      this.api = api;
    }
    getMultiActivationStatuses(businessIds) {
      return this.api.getMultiActivationStatuses({
        businessIds: businessIds
      }).pipe(map(resp => resp.activationStatuses || []));
    }
    listActiveAccountsForProduct(req) {
      return this.api.listActiveAccountsForProduct(req);
    }
  }
  AccountsService.ɵfac = function AccountsService_Factory(t) {
    return new (t || AccountsService)(i0.ɵɵinject(AccountsApiService));
  };
  AccountsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountsService,
    factory: AccountsService.ɵfac,
    providedIn: 'root'
  });
  return AccountsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { AccountsApiService, AccountsService, ActivateProductRequest, ActivateProductResponse, ActivationStatus, Blame, BlameDeactivationReasons, BlameSource, ChangeEditionRequest, ChangeEditionResponse, GetMultiActivationStatusesRequest, GetMultiActivationStatusesResponse, GetMultiActivationStatusesResponseAppsAndAddonsActivationStatuses, ListActiveAccountsForProductRequest, ListActiveAccountsForProductResponse, ListActiveAccountsForProductResponseActiveProducts };
